import { useCurrentUser } from '@cosuno/authentication-frontend';
import { useModalState } from '@cosuno/modal-frontend';
import { generateFrontendRoutes } from '@cosuno/routes';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { type PRICING_PLAN, USER_TYPE } from '~/__gql__/graphql';
import { type ANALYTICS_ENTRY_POINT, AnalyticsEntryPoint } from '~/packages/Analytics';
import { toast } from '~/packages/Toast';

import { PricingPlanModal } from './PricingPlanModal';

const routes = generateFrontendRoutes({ withoutWorkspace: true });

export default function useShowPricingPlan(
  highlightedPlan: PRICING_PLAN | null = null,
  entrypoint?: ANALYTICS_ENTRY_POINT,
) {
  const history = useHistory();
  const user = useCurrentUser();
  const modalState = useModalState();

  const showPricingPlan = useCallback(() => {
    try {
      if (user?.type === USER_TYPE.administrator) {
        history.push(routes.pricingPlans({ plan: highlightedPlan ?? undefined }), { entrypoint });
      } else {
        modalState.openModal();
      }
    } catch (error) {
      toast.error(error);
    }
  }, [entrypoint, highlightedPlan, history, modalState, user?.type]);

  const renderModal = () => (
    <AnalyticsEntryPoint value={entrypoint}>
      <PricingPlanModal highlightedPlan={highlightedPlan} {...modalState} />
    </AnalyticsEntryPoint>
  );

  return { renderModal, showPricingPlan };
}
